import React, { useState, useEffect, Fragment } from 'react';
import Bunexe_service from '../../Bunexe_service';

const ListeEcole = ({
  text_rech,
  setTexte_Recherche,
  setEcole_selectionne,
  code_dept,
  eni,
}) => {
  let url_ = Bunexe_service.url;
  //'http://localhost:8086';
  const suite_ = !eni
    ? `/ecole/${code_dept}/${text_rech}`
    : `/ecole/eni/${code_dept}/${text_rech}`;
  const [liste_ecoles, setListe_ecole] = useState([]);
  const RechercherEcolesParNom = async (code_dept, text_rech) => {
    try {
      //fetch(url_ + `/ecole/${code_dept}/${text_rech}`)
      fetch(url_ + suite_)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          setListe_ecole(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    RechercherEcolesParNom(code_dept, text_rech);
  }, [text_rech]);
  return (
    <div className='container'>
      {liste_ecoles.length == 0 && setEcole_selectionne(null)}
      {/* <h2 className='text-center'>ListeEcole</h2> */}
      <div className='border rounded p-3'>
        <table className='table table-sm table-hover'>
          <thead>
            <tr>
              <th className='text-center'>Liste des ecoles</th>
            </tr>
          </thead>
          <tbody style={{ height: '360px', overflowY: 'auto' }}>
            {/* <div style={{ height: '360px', overflowY: 'auto' }}> */}
            {liste_ecoles.length > 0 &&
              liste_ecoles.map((ec) => (
                <tr
                  key={ec.Ecole}
                  style={{ width: '100%' }}
                  onClick={(e) => setEcole_selectionne(ec)}
                >
                  <td style={{ width: '100%' }}>
                    <h5>{ec.LibelleEt}</h5>
                    <small>
                      {ec.Ecole} - {ec.AdresseEt}{' '}
                    </small>
                  </td>
                </tr>
              ))}
            {/* </div> */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListeEcole;
